import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import { useUser } from "../../../../context";
import redeem from "../../../../i11/Redeem";

const Row = ({ data, open, exp = false, fullData = {} }) => {
	const { locale } = useUser();
	const date = new Date(data.updatedAt);
	return (
		<>
			<div className={styles.row}>
				<div className={styles.col} />
				<div className={styles.col}>
					<div
						className={styles.item}
						onClick={() => open(exp ? fullData : data)}
					>
						<div className={styles.avatar}>
							<img src={data.image} alt={data.name} />
						</div>
						<div className={styles.details}>
							<div className={styles.user}>{data.name}</div>
						</div>
					</div>
				</div>
				<div className={styles.col}>{data.owner?.userName}</div>
				<div className={styles.col}>{date.toLocaleString()}</div>
				<div className={cn(styles.col)}>
					<div className={styles.flex}>
						<div
							className={cn(
								styles[data.redeemStatus],
								styles.status
							)}
						>
							{exp
								? redeem[locale].expStat[data.redeemStatus]
								: redeem[locale].statuses[data.redeemStatus]}
						</div>
					</div>
				</div>
				<div className={styles.col}>
					<button
						onClick={() => open(exp ? fullData : data)}
						className="button-stroke button-small"
					>
						{redeem[locale].detail}
					</button>
				</div>
			</div>
		</>
	);
};

export default Row;
